import React from 'react';
import {
  List,
  Datagrid,
  Create,
  SimpleForm,
  EditButton,
  DeleteButton,
  TextInput,
  TextField,
  translate as t,
} from 'admin-on-rest';

import Edit from '../components/Edit';

export const RecipeList = (props) => (
  <List {...props}>
    <Datagrid>
      <TextField source="name" />
      <EditButton {...props} basePath="/recipes" />
      <DeleteButton {...props} basePath="/recipes" />
    </Datagrid>
  </List>
);

const RecipeTitle = t(({ record, translate }) => (
  <span>{record ? translate('edit.title', { title: record.description }) : ''}</span>
));

const Form = (props) => (
  <SimpleForm {...props} redirect="list">
    <TextInput source="name" />
  </SimpleForm>
);

export const RecipeEdit = (props) => (
  <Edit title={<RecipeTitle />} {...props}>
    <Form {...props} />
  </Edit>
);

export const RecipeCreate = (props) => (
  <Create {...props}>
    <Form {...props} />
  </Create>
);
